(() => {
  const SNOOZE_KEY = 'rv3d_popup_snooze_until';
  const SUBMITTED_KEY = 'rv3d_popup_submitted_v1';
  const THREE_DAYS = 3 * 24 * 60 * 60 * 1000;
  const LIVE_DELAY = 7000;
  const PREVIEW_DELAY = 600;
  const LEGACY_KLAVIYO_FORM_IDS = ['X8S9d5', 'WwvG5i', 'SAuibU'];

  const qs = (root, selector) => root.querySelector(selector);
  const qsa = (root, selector) => Array.from(root.querySelectorAll(selector));

  function isPreview() {
    const params = new URLSearchParams(window.location.search);
    return params.has('preview_theme_id') ||
      params.get('rv3d') === '1' ||
      Boolean(window.Shopify && window.Shopify.designMode);
  }

  function readCookie(name) {
    const prefix = `${name}=`;
    const part = document.cookie.split('; ').find((item) => item.startsWith(prefix));
    return part ? part.slice(prefix.length) : '';
  }

  function decodeKlaviyoCookie(value) {
    if (!value) return null;

    const candidates = [value];
    try {
      candidates.unshift(decodeURIComponent(value));
    } catch (_) {}

    for (const candidate of candidates) {
      try {
        if (candidate.trim().startsWith('{')) return JSON.parse(candidate);
      } catch (_) {}

      try {
        const normalized = candidate.replace(/-/g, '+').replace(/_/g, '/');
        const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
        const decoded = atob(padded);
        return JSON.parse(decoded);
      } catch (_) {}
    }

    return null;
  }

  function isKlaviyoIdentified() {
    const data = decodeKlaviyoCookie(readCookie('__kla_id'));
    return Boolean(data && data.exchange_id);
  }

  function init() {
    const root = document.querySelector('[data-rv3d]');
    const preview = isPreview();
    if (!root) return;

    const scene = qs(root, '[data-rv3d-scene]');
    const product = qs(root, '[data-rv3d-product]');
    const reveal = qs(root, '[data-rv3d-reveal]');
    const form = qs(root, '[data-rv3d-form]');
    const email = qs(root, '#rv3d-email');
    const error = qs(root, '[data-rv3d-error]');
    const submit = qs(root, '[data-rv3d-submit]');
    const submitLabel = qs(root, '[data-rv3d-submit-label]');
    const closeButtons = qsa(root, '[data-rv3d-close]');
    const lang = (root.dataset.lang || 'en').slice(0, 2);
    const localeMap = { es: 'es-ES', fr: 'fr-FR', en: 'en' };
    const sourceMap = { es: 'POP UP - ES', fr: 'POP UP - FR', en: 'POP UP - EN' };
    let lastFocused = null;
    let raf = null;

    const legacySelectors = LEGACY_KLAVIYO_FORM_IDS.flatMap((id) => [
      `.klaviyo-form-${id}`,
      `[id*="${id}"]`,
      `[class*="${id}"]`,
      `[data-testid*="${id}"]`,
      `[data-form-id*="${id}"]`,
      `[data-klaviyo-form*="${id}"]`
    ]).join(',');

    const strings = {
      es: {
        invalid: 'Introduce un correo electrónico válido.',
        error: 'No hemos podido activar tu Discovery Gift. Inténtalo de nuevo.',
        loading: 'ACTIVANDO…'
      },
      fr: {
        invalid: 'Veuillez saisir une adresse e-mail valide.',
        error: 'Nous n’avons pas pu activer votre Discovery Gift. Veuillez réessayer.',
        loading: 'ACTIVATION…'
      },
      en: {
        invalid: 'Please enter a valid email address.',
        error: 'We couldn’t activate your Discovery Gift. Please try again.',
        loading: 'ACTIVATING…'
      }
    };
    const copy = strings[lang] || strings.en;

    function matchesLegacyForm(element) {
      return Boolean(element && element.matches && element.matches(legacySelectors));
    }

    function findLegacyForm(scope) {
      if (!scope || !scope.querySelector) return null;
      if (scope instanceof Element && matchesLegacyForm(scope)) return scope;
      return scope.querySelector(legacySelectors);
    }

    function hideLegacyPopup(match) {
      if (!(match instanceof Element)) return;

      let target = match;
      let current = match;

      for (let depth = 0; depth < 12 && current && current !== document.body; depth += 1) {
        const isDialog = current.getAttribute('role') === 'dialog' ||
          current.getAttribute('aria-modal') === 'true';
        let isFixed = false;

        try {
          isFixed = window.getComputedStyle(current).position === 'fixed';
        } catch (_) {}

        if (isDialog || isFixed) target = current;
        current = current.parentElement;
      }

      target.style.setProperty('display', 'none', 'important');
      target.style.setProperty('visibility', 'hidden', 'important');
      target.style.setProperty('pointer-events', 'none', 'important');
      target.setAttribute('aria-hidden', 'true');
      target.setAttribute('data-rv3d-legacy-suppressed', 'true');
    }

    function suppressLegacyPopups(scope = document) {
      const match = findLegacyForm(scope);
      if (match) hideLegacyPopup(match);

      if (scope && scope.querySelectorAll) {
        scope.querySelectorAll(legacySelectors).forEach(hideLegacyPopup);
      }
    }

    suppressLegacyPopups(document);

    const legacyObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) suppressLegacyPopups(node);
        });
      });
    });

    if (document.body) {
      legacyObserver.observe(document.body, { childList: true, subtree: true });
    }

    function setStep(name) {
      qsa(root, '[data-rv3d-step]').forEach((step) => {
        const active = step.dataset.rv3dStep === name;
        step.classList.toggle('is-active', active);
        step.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      root.classList.toggle('is-revealed', name !== 'intro');

      if (name === 'form') {
        window.setTimeout(() => email && email.focus({ preventScroll: true }), 180);
      }
    }

    function open() {
      suppressLegacyPopups(document);
      lastFocused = document.activeElement;
      root.hidden = false;
      document.body.classList.add('rv3d-lock');

      requestAnimationFrame(() => {
        root.classList.add('is-open');
        scene && scene.focus({ preventScroll: true });
      });
    }

    function snooze() {
      if (preview) return;
      try {
        localStorage.setItem(SNOOZE_KEY, String(Date.now() + THREE_DAYS));
      } catch (_) {}
    }

    function markSubmitted() {
      if (preview) return;
      try {
        localStorage.setItem(SUBMITTED_KEY, '1');
        localStorage.removeItem(SNOOZE_KEY);
      } catch (_) {}
    }

    function close({ snoozePopup = true } = {}) {
      if (snoozePopup) snooze();

      root.classList.remove('is-open');
      document.body.classList.remove('rv3d-lock');

      window.setTimeout(() => {
        root.hidden = true;
        setStep('intro');
        resetTilt();

        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus({ preventScroll: true });
        }
      }, 420);
    }

    function shouldOpen() {
      if (preview) return true;

      try {
        if (localStorage.getItem(SUBMITTED_KEY) === '1') return false;
        const until = Number(localStorage.getItem(SNOOZE_KEY) || 0);
        if (Date.now() < until) return false;
      } catch (_) {}

      if (isKlaviyoIdentified()) return false;

      return true;
    }

    function onPointerMove(event) {
      if (!scene || window.matchMedia('(max-width: 749px)').matches) return;

      const rect = scene.getBoundingClientRect();
      const nx = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      const ny = ((event.clientY - rect.top) / rect.height) * 2 - 1;

      if (raf) cancelAnimationFrame(raf);

      raf = requestAnimationFrame(() => {
        scene.style.setProperty('--rv-prod-x', `${(nx * 18).toFixed(2)}px`);
        scene.style.setProperty('--rv-prod-y', `${(ny * 11).toFixed(2)}px`);
        scene.style.setProperty('--rv-prod-ry', `${(nx * 6.5).toFixed(2)}deg`);
        scene.style.setProperty('--rv-prod-rx', `${(ny * -4.5).toFixed(2)}deg`);
        scene.style.setProperty('--rv-card-ry', `${(nx * 1.2).toFixed(2)}deg`);
        scene.style.setProperty('--rv-card-rx', `${(ny * -1).toFixed(2)}deg`);
      });
    }

    function resetTilt() {
      if (!scene) return;

      scene.style.setProperty('--rv-prod-x', '0px');
      scene.style.setProperty('--rv-prod-y', '0px');
      scene.style.setProperty('--rv-prod-ry', '0deg');
      scene.style.setProperty('--rv-prod-rx', '0deg');
      scene.style.setProperty('--rv-card-ry', '0deg');
      scene.style.setProperty('--rv-card-rx', '0deg');
    }

    async function syncProfileProperties(emailValue) {
      const endpoint = `https://a.klaviyo.com/client/profiles?company_id=${encodeURIComponent(root.dataset.klaviyoKey)}`;
      const payload = {
        data: {
          type: 'profile',
          attributes: {
            email: emailValue,
            locale: localeMap[lang] || 'en',
            properties: {
              Language: lang
            }
          }
        }
      };

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'Accept': 'application/vnd.api+json',
          'revision': '2026-07-15'
        },
        body: JSON.stringify(payload),
        mode: 'cors',
        credentials: 'omit'
      });

      if (response.status !== 202) {
        throw new Error(`Klaviyo profile property sync failed: ${response.status}`);
      }
    }

    async function subscribe(event) {
      event.preventDefault();

      if (!email || !email.validity.valid) {
        if (error) error.textContent = copy.invalid;
        email && email.focus();
        return;
      }

      if (error) error.textContent = '';
      submit.disabled = true;

      const originalLabel = submitLabel.textContent;
      submitLabel.textContent = copy.loading;

      const emailValue = email.value.trim();
      const source = sourceMap[lang] || sourceMap.en;
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: emailValue,
                  locale: localeMap[lang] || 'en',
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: root.dataset.klaviyoList
              }
            }
          }
        }
      };

      try {
        const endpoint = `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(root.dataset.klaviyoKey)}`;
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json',
            'revision': '2026-07-15'
          },
          body: JSON.stringify(payload),
          mode: 'cors',
          credentials: 'omit'
        });

        if (response.status !== 202) {
          let detail = '';
          try {
            const body = await response.json();
            detail = body?.errors?.[0]?.detail || '';
          } catch (_) {}
          throw new Error(`Klaviyo subscription failed: ${response.status}${detail ? ` · ${detail}` : ''}`);
        }

        await syncProfileProperties(emailValue);
        markSubmitted();
        setStep('success');
      } catch (err) {
        console.error('[ROY VIROK 3D popup]', err);
        if (error) error.textContent = copy.error;
      } finally {
        submit.disabled = false;
        submitLabel.textContent = originalLabel;
      }
    }

    reveal && reveal.addEventListener('click', () => setStep('form'));
    form && form.addEventListener('submit', subscribe);

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const isBackdrop = button.classList.contains('rv3d__backdrop');
        if (isBackdrop && !window.matchMedia('(max-width: 749px)').matches) return;
        close({ snoozePopup: true });
      });
    });

    scene && scene.addEventListener('pointermove', onPointerMove, { passive: true });
    scene && scene.addEventListener('pointerleave', resetTilt);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) {
        close({ snoozePopup: true });
      }
    });

    product && product.addEventListener('dragstart', (event) => event.preventDefault());

    const delay = preview ? PREVIEW_DELAY : LIVE_DELAY;
    window.setTimeout(() => {
      if (shouldOpen()) open();
    }, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
